module.exports = __webpack_public_path__ + "img/arrows-sort.4f4482b6.svg";